module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "download-app"
  }, [_c('div', {
    staticClass: "info"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/douban-app-logo.png"),
      "alt": "下载豆瓣"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "info-content"
  }, [_c('strong', [_vm._v("豆瓣")]), _vm._v(" "), _c('div', [_vm._v("我们的精神角落")])])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("去 App Store 免费下载 iOS 客户端")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b85489d2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/DownloadApp.vue
// module id = 207
// module chunks = 0